import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type ForensicRow } from '../api';

export function ForensicPage() {
  const [rows, setRows] = useState<ForensicRow[]>([]);

  useEffect(() => {
    api.forensicList({}).then((d) => setRows(d.rows));
  }, []);

  return (
    <div className="card">
      <h2>Forensic (RUF) reports</h2>
      <p className="muted">
        Per-message auth-failure reports parsed from inbound RFC&nbsp;6591 / AFRF emails. Most receivers
        only send these on request and may strip message content for privacy.
      </p>
      {rows.length === 0 ? (
        <p className="muted">No forensic reports imported yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>When</th>
              <th>Domain</th>
              <th>Source IP</th>
              <th>Auth failure</th>
              <th>From</th>
              <th>Subject</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="muted">
                  {r.arrival_date
                    ? new Date(r.arrival_date).toLocaleString()
                    : new Date(r.imported_at).toLocaleString()}
                </td>
                <td>
                  <Link to={`/forensic/${r.id}`}>{r.reported_domain ?? '—'}</Link>
                </td>
                <td>{r.source_ip ?? '—'}</td>
                <td>{r.auth_failure ?? '—'}</td>
                <td>{r.original_mail_from ?? '—'}</td>
                <td className="muted">{r.subject ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
